<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline' class="m-b-25">
        <a-form-item label="会员信息" name='keyword'>
          <a-input-group compact>
            <a-input v-model:value="search.member_name" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="活动信息" name='keyword'>
          <a-input-group compact>
            <a-input v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="收集时间">
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button class='m-r-10' v-has:membersExport="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='member_id' :columns='columns' :data-source='data'>
          <template v-slot:action="{ record }">
            <a v-has:membersDetail="()=>userDetail(record)" href="javascript:;">查看</a>
          </template>
          <template v-slot:activity_name="{ record }">
            <p>{{record.activity_id}}--{{record.activity_name}}</p>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `共 ${total} 条`" />
      </div>
    </a-card>
  </a-layout>
  <!-- 查看 -->
  <a-modal :keyboard="false" title="更多信息" centered v-model:visible="showRedList" :width='800' :footer="null" destroyOnClose>
    <redLog :list='anotherlist'></redLog>
  </a-modal>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject, h } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { memberCollectionsList } from "@/api/qrcodeActivitys.js";
import redLog from "./components/redLog.vue";
const def = {
  page: 1,
  limit: 10,
  member_name: "",
  keyword: "",
  // brandId:"10010001",
  start_time: "",
  end_time: "",
};

let time = null;
export default {
  components: { redLog },
  name: "collect",
  setup() {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      listItem: {},
      integral: "",
      integralRemarks: "",
      growthValue: "",
      tagsList: [],
      showRedList: false, //查看
      anotherlist: [],
      time: [],
    });
    let data = ref();
    let columns = [
      {
        title: "活动信息",
        dataIndex: "activity_name",
        key: "activity_name",
        slots: { customRender: "activity_name" },
      },
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
      },
      {
        title: "姓名",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "手机号",
        dataIndex: "mobile",
        key: "mobile",
      },
      {
        title: "手机号（验证）",
        dataIndex: "mobile_check",
        key: "mobile_check",
      },
      {
        title: "生日",
        dataIndex: "birthday",
        key: "birthday",
      },
      {
        title: "性别",
        dataIndex: "sex",
        key: "sex",
      },

      {
        title: "关联门店",
        dataIndex: "store",
        key: "store",
      },
      {
        title: "收集时间",
        dataIndex: "time",
        key: "time",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];

    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      let res = await memberCollectionsList({
        ...values,
      }).then((res) => res.data);
      if (iscode(res)) {
        data.value = res.data.data;
        console.log(data.value);
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    const $Modal = inject("$Modal");

    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };
    onMounted(() => {
      initData(search.value);
    });
    const $router = inject("$router");
    const $route = inject("$route");
    // 导出
    const exportTable = async () => {
      let res = await memberCollectionsList({ ...search.value, excel: 1 }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.url);
      }
    };
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const userDetail = async (value) => {
      state.showRedList = true;
      state.anotherlist = value.another;
    };
    const changeTab = (e) => {
      search.value.page = 1;
      search.value.limit = 10;
      data.value = [];
      initData(search.value);
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      inputSelect,
      userDetail,
      onsubmit,
      exportTable,
      changeTab,
      onChange,
    };
  },
};
</script>